export default __webpack_public_path__ + "static/media/fish&chips-bolditalic.3ca60875.woff2";